import Phaser from 'phaser';
import { SCENE_KEYS } from '../config';

export class MenuScene extends Phaser.Scene {
  constructor() { super({ key: SCENE_KEYS.MENU }); }
  create(): void {
    const { width, height } = this.cameras.main;
    this.cameras.main.setBackgroundColor('#000000');
    this.add.text(width / 2, height / 3, 'GUAYABERA-Z', {
      fontSize: '64px', fontFamily: 'Arial Black, sans-serif', color: '#ffcc00', fontStyle: 'bold',
    }).setOrigin(0.5);
    this.add.text(width / 2, height / 3 + 60, 'PATRIA Y VIDA', {
      fontSize: '32px', fontFamily: 'Arial, sans-serif', color: '#ffffff',
    }).setOrigin(0.5);
    const startText = this.add.text(width / 2, height / 2 + 40, 'PRESS ENTER OR TAP TO START', {
      fontSize: '24px', fontFamily: 'Arial, sans-serif', color: '#ffffff',
    }).setOrigin(0.5);
    this.tweens.add({ targets: [startText], alpha: 0.2, duration: 800, yoyo: true, repeat: -1 });
    const startGame = () => this.scene.start(SCENE_KEYS.BRIEFING, {
      title: 'CENTRO HABANA',
      text: 'Escapa del barrio y llega al Malecón.\nDerrota a los enemigos con piedras o saltando.\nRecoge dinero y power-ups por el camino.',
    });
    this.input.keyboard?.on('keydown-ENTER', startGame);
    this.input.on('pointerdown', startGame);
  }
}
